import React from 'react'
import { Container } from '../../components_renew/Layout'

class Version extends React.PureComponent {
  state = (() => {
    let appInfo = []
    for (let i in window.appInfo) {
      if (window.appInfo.hasOwnProperty(i)) {
        appInfo.push({ key: i, value: window.appInfo[i] })
      }
    }
    return {
      appInfo
    }
  })()

  render () {
    return <Container>
      {this.state.appInfo.map(item => {
        return <div key={item['key']}>{item['key']}: {item['value']}</div>
      })}
    </Container>
  }
}

export default Version
